import createClass from 'create-react-class'
import FormBase from 'live/components/extensions/ui/form'
import React from 'react'
import FormGroup from 'live/components/forms/ui/form-group'
import ActionToggle from 'live/components/ui/action-toggle'
import i18n from 'live/services/i18n'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixinFactory from 'live/components/forms/mixins/object-initializer'
import { FormEnabledContext } from 'live/context/form-enabled'
import styled from 'styled-components'
import UnitManagementForm, { ToDataResult } from './components/UnitManagementForm'
import TopicManagementForm, { TopicDataResult } from './components/TopicManagementForm'

const ObjectInitializerMixin = ObjectInitializerMixinFactory('/rest/extension', {
    type: 'mqttinputclient',
    active: true,
    config: {
        port: 1883,
        enableForInput: true,
        identifier: 'live-mqtt-plugin',
        brokerAddress: 'tcp://localhost',
        user: null,
        password: null,
        topicConfigList: [],
        sslKeyAlias: 'mqtt',
        sslKeyStore: null,
        sslStorePass: null,
        sslTrustStore: null,
        sslTrustPass: null,
        serverHostnameVerification: true,
        flatten: true
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const validations = {
    properties: {
        config: {
            properties: {
                uomMap: {
                    type: 'object',
                    required: false,
                    allowEmpty: true,
                    message: i18n('UOM list error. Check details')
                },
                topicConfigList: {
                    type: 'array',
                    required: true,
                    allowEmpty: true,
                    message: i18n('Topic_Error')
                }
            }
        }
    }
}
const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations,

    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },

    _onDelete: function () {
        window.location.href = '#/integrations/'
    },

    onToggleHostnameVerification() {
        const object = this.state.object
        const config = object.config

        config.serverHostnameVerification = !config.serverHostnameVerification
        this.applyObj({ config: config })
        this.validateProperty('serverHostnameVerification', config.serverHostnameVerification)
    },

    onToggleFlattenJSON() {
        const object = this.state.object
        const config = object.config

        config.flatten = !config.flatten
        this.applyObj({ config: config })
    },

    onChangeCheckbox: function (e) {
        const object = this.state.object
        const config = object.config
        const field = e.target.name

        config[field] = !config[field]
        this.applyObj({ config: config })
        this.handleValidation(e)
    },

    applyUomMap: function (uomMap: ToDataResult) {
        const object = this.state.object
        const config = object.config

        if (uomMap.errMsg == null) {
            config.uomMap = uomMap.data
            this.applyObj({ config: config })
        }
    },

    applyTopicConfigList: function (topicConfigList: TopicDataResult) {
        const object = this.state.object
        const config = object.config

        if (topicConfigList.errMsg === null) {
            config.topicConfigList = topicConfigList.data
            this.applyObj({ config: config })
        }
    },

    render: function () {
        const object = this.state.object
        const config = object.config || {}
        const uomMap = config.uomMap || {}
        const topicConfigList = config.topicConfigList || []

        // This verification is made to keep the interface consistent with the previous version of the plugin.
        if (typeof config.flatten === 'undefined') config.flatten = true

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('MQTT client connection configurations')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('MQTT identifier')}
                        name="config.identifier"
                        value={config.identifier}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.identifier')}
                        hasFeedback
                        help={this.errorsFor('config.identifier')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Broker address')}
                        name="config.brokerAddress"
                        value={config.brokerAddress}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.brokerAddress')}
                        hasFeedback
                        help={this.errorsFor('config.brokerAddress')}
                    />

                    <FormGroup
                        type="number"
                        label={i18n('Input Port')}
                        name="config.port"
                        value={parseInt(config.port)}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.port')}
                        hasFeedback
                        help={this.errorsFor('config.port')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('User (optional)')}
                        name="config.user"
                        value={config.user}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.user')}
                        hasFeedback
                        help={this.errorsFor('config.user')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Password (optional)')}
                        name="config.password"
                        value={config.password}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.password')}
                        hasFeedback
                        help={this.errorsFor('config.password')}
                    />
                </div>

                <TopicForm className="form-area">
                    <h3>{i18n('Topic_Management')}</h3>

                    <TopicManagementForm dataObject={topicConfigList} caller={this.applyTopicConfigList} />
                </TopicForm>

                <h3 className="pos-form">
                    {i18n('SSL Configuration')}
                    <pre className="help-block">{i18n('SSLConfiguration Help')}</pre>
                </h3>

                <div className="form-area">
                    <FormGroup
                        type="text"
                        label={i18n('KeyStore Path')}
                        name="config.sslKeyStore"
                        value={config.sslKeyStore}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.sslKeyStore')}
                        hasFeedback
                        help={this.errorsFor('config.sslKeyStore')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('KeyStore Password')}
                        name="config.sslStorePass"
                        value={config.sslStorePass}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.sslStorePass')}
                        hasFeedback
                        help={this.errorsFor('config.sslStorePass')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Key Alias')}
                        name="config.sslKeyAlias"
                        value={config.sslKeyAlias}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.sslKeyAlias')}
                        hasFeedback
                        help={this.errorsFor('config.sslKeyAlias')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Trusted Store Path')}
                        name="config.sslTrustStore"
                        value={config.sslTrustStore}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.sslTrustStore')}
                        hasFeedback
                        help={this.errorsFor('config.sslTrustStore')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Trusted Store Password')}
                        name="config.sslTrustPass"
                        value={config.sslTrustPass}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.sslTrustPass')}
                        hasFeedback
                        help={this.errorsFor('config.sslTrustPass')}
                    />

                    <div className="form-group">
                        <label>{i18n('Enable Hostname Verification')}</label>
                        <ActionToggle
                            onChange={this.onToggleHostnameVerification}
                            active={config.serverHostnameVerification}
                        />
                        {config.serverHostnameVerification ? (
                            <Disclaimer>{i18n('Server Hostname Verification Info')}</Disclaimer>
                        ) : (
                            ''
                        )}
                    </div>

                    <div className="form-group">
                        <label>{i18n('Keep nested JSON objects')}</label>
                        <ActionToggle onChange={this.onToggleFlattenJSON} active={!config.flatten} />
                        {!config.flatten ? (
                            <Disclaimer>
                                {i18n('Messages are inserted into LIVE without any format changes.')}
                            </Disclaimer>
                        ) : (
                            <Disclaimer>
                                {i18n('Received messages are converted to a format compatible with LIVE channels.')}
                            </Disclaimer>
                        )}
                    </div>
                </div>
                <div className="form-area">
                    <h3>{i18n('Unit management')}</h3>

                    <UnitManagementForm dataObject={uomMap} caller={this.applyUomMap} />
                </div>
            </FormBase>
        )
    }
})

Form.contextType = FormEnabledContext

const Disclaimer = styled.div`
    color: ${({ theme }) => theme['text-danger']};
    padding-top: 5px;
`

const TopicForm = styled.div`
    padding-top: 10px;
    margin-bottom: 20px;
`

export default Form
